

import { makeStyles } from 'tss-react/mui';
import React from 'react';
import { Box, Grid, KeyValue } from 'web-library';
import { useTranslation } from 'react-i18next';
import FormHeader from './form-items/FormHeader';
import { ResitSimplePaymentDetail } from '../models/@candidate/candidateResitRegistrationSchema';
import { stringToLongDateAndShortTime } from '../utils/DateUtils';

const useStyles = makeStyles()((theme) =>
({
  container: {
    paddingBottom: theme.spacing(3),
    maxWidth: 1280,
  },
  sectionTitle: {
    paddingTop: theme.spacing(2),
    marginBottom: theme.spacing(3),
  },
}));

const ReceiptDetails = ({ transaction }: { transaction: ResitSimplePaymentDetail | undefined }) => {
  const { classes } = useStyles();
  const { t } = useTranslation();

  const paymentDate = transaction?.paymentTimeStamp
    ? stringToLongDateAndShortTime(transaction.paymentTimeStamp)
    : null;

  const totalFee =
    transaction?.totalFee && transaction.totalFee !== '' ? `S$ ${transaction?.totalFee}` : 'N/A';

  return (
    <Box className={classes.container}>
      <FormHeader title={t('components->>ReceiptDetails.Transaction Details')} />
      {transaction?.noOfCandidates && (
        <KeyValue
          keyText={t('components->>ReceiptDetails.No. of Candidate(s)')}
          capitalize={false}
          valueText={`${transaction?.noOfCandidates}`}
        />
      )}
      <Grid container>
        <Grid xs={12} sm={6}>
          <KeyValue
            keyText={t('components->>ReceiptDetails.TransactionDateTime')}
            id="transactionDateTime"
            valueText={paymentDate || 'N/A'}
          />
        </Grid>
        <Grid xs={12} sm={6}>
          <KeyValue
            id="transactionNo"
            keyText={t('components->>ReceiptDetails.Transaction No.')}
            valueText={transaction?.transactionNumber || 'N/A'}
          />
        </Grid>
      </Grid>
      <Grid container>
        <Grid xs={12} sm={6}>
          <KeyValue
            keyText={t('components->>ReceiptDetails.Amount Paid (SGD)')}
            valueText={`${totalFee}`}
            id="amountPaid"
          />
        </Grid>
        <Grid xs={12} sm={6}>
          <KeyValue
            keyText={t('components->>ReceiptDetails.Payment Method')}
            valueText={transaction?.paymentMethod}
            id="paymentMethod"
          />
        </Grid>
      </Grid>
      <Grid container>
        <Grid xs={12} sm={6}>
          <KeyValue
            id="referenceNo"
            keyText={t('components->>ReceiptDetails.Reference No.')}
            valueText={transaction?.internalTransactionRef || 'N/A'}
          />
        </Grid>
        <Grid xs={12} sm={6}>
          <KeyValue
            keyText={t('components->>ReceiptDetails.GST Reg No.')}
            valueText={`${transaction?.gstRegNo}`}
            id="gstRegNo"
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default ReceiptDetails;
